'use client';

import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@/shared/lib/tailwind-merge';

const BaseProgress = React.forwardRef<
    React.ElementRef<typeof ProgressPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, children, ...props }, ref) => (
    <ProgressPrimitive.Root
        ref={ref}
        className={cn('relative h-2 w-full rounded-full bg-primary/20', className)}
        {...props}
    >
        {children ? (
            children
        ) : (
            <ProgressPrimitive.Indicator
                className='h-full w-full flex-1 bg-primary transition-all'
                style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
            />
        )}
    </ProgressPrimitive.Root>
));
BaseProgress.displayName = ProgressPrimitive.Root.displayName;

export { BaseProgress };
